import { Routes } from '@angular/router';
import {  AppAccessGuard, AuthGuard, ForbiddenComponent } from '@core';
import { LayoutComponent } from '@core/features';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: async () => (await import('./pages/auth')).routes,
    },
    {
        path: 'forbidden',
        component: ForbiddenComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [AppAccessGuard],
        data: {
            app: 'Admin',
            skipAppCheck: true // Admin es accesible para todos los usuarios autenticados
        },
        children: [
            {
                title: 'Usuarios',
                path: 'users',
                canActivate: [AuthGuard],
                loadChildren: async () => (await import('./pages/users')).routes,

                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION', 'ROLE_ADMON_GESTION_USUARIOS'] },
            },
            {
                title: 'Empresas',
                path: 'company',
                loadChildren: async () => (await import('./pages/company')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },
            {
                title: 'Proyectos',
                path: 'projects',
                loadChildren: async () => (await import('./pages/projects')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },

            {
                path: 'projects-tags',
                loadChildren: async () => (await import('./pages/projects-tags')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },

            {
                path: 'projects-sistemas',
                loadChildren: async () => (await import('./pages/projects-sistemas')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },

            {
                path: 'projects-caducados',
                loadChildren: async () => (await import('./pages/projects-caducados')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },

            {
                title: 'Sistemas',
                path: 'sistemas',
                loadChildren: async () => (await import('./pages/sistemas')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },

            {
                title: 'Paquetes de Trabajo',
                path: 'paquetes-trabajo',
                loadChildren: async () => (await import('./pages/paquetes-trabajo')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },

            {
                title: 'Tags',
                path: 'tags',
                loadChildren: async () => (await import('./pages/tags')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },
            {
                title: 'Plantas',
                path: 'plantas',
                loadChildren: async () => (await import('./pages/plantas')).routes,
                canActivate: [AuthGuard],
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },
            {
                title: 'Especialidad',
                path: 'especialidad',
                canActivate: [AuthGuard],
                loadChildren: async () => (await import('./pages/especialidad/especialidad.routes')).routes,
                data: { roles: ['ROL_ADMON_EQUIPO_ADMINISTRACION'] },
            },

            {
                title: 'Importador',
                path: 'importador',
                loadComponent: () => import('./pages/importador/importador.component').then(m => m.ImportadorComponent),
                canActivate: [AuthGuard],
            },
            {
                title: 'Reportes',
                path: 'reports',
                loadChildren: async () => (await import('./pages/reports')).routes,
            },
            {
                title: 'Aplicaciones',
                path: 'applications',
                loadComponent: () => import('./pages/applications/applications.component').then(m => m.ApplicationsComponent),
                canActivate: [AuthGuard],
                //data: { roles: ['Admin'] }
            },
            {
                title: 'Perfil',
                path: 'perfil',
                loadChildren: async () => (await import('./pages/cuenta')).routes,
                canActivate: [AuthGuard],
                //data: { roles: ['Admin'] }
            },
            {
                path: '',
                loadChildren: async () => (await import('./pages/home')).routes,
                canActivate: [AuthGuard],
                //data: { roles: ['Admin'] }
            },
        ],
    },
];
